function Closesession() {
    localStorage.removeItem('token'); // Opcional: Elimina el token inválido
    localStorage.setItem("isRegister", "false");
    localStorage.setItem("isLoggedIn", "false");
    localStorage.setItem("idPerfil", "0");
    localStorage.setItem("isLoggedIn", "false");
    window.location.reload();
  }

  export default Closesession;
